var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Sha256 } from '@aws-crypto/sha256-js';
class _ImagesManager {
    constructor() {
        this.db = null;
        // this.ImgsCache = {};
        this.initializeDb();
    }
    initializeDb() {
        void this.InitDB().then((db) => {
            this.db = db;
        });
    }
    GetSvg(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const sha_name = yield this.getSHA256(url);
                const data = yield this.DB_Get(this.db, sha_name);
                let imgSVG = data.imgData;
                if (!data.success || !imgSVG) {
                    imgSVG = yield this.LoadIMG(url);
                    if (imgSVG) {
                        yield this.DB_Add(this.db, sha_name, imgSVG);
                    }
                }
                return imgSVG;
            }
            catch (err) {
                return null;
            }
        });
    }
    GetImg(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, w = 24, h = 24, a = 1) {
            let img = new Image();
            if (!this.db) {
                return null;
            } // empty IMG
            try {
                const imgSVG = yield this.GetSvg(url);
                if (!imgSVG) {
                    return null;
                }
                img = yield this.SVGtoIMG(imgSVG, w, h, a);
            }
            catch (err) {
                return null;
            }
            return yield new Promise((resolve, reject) => {
                resolve(img);
            });
        });
    }
    SVGtoIMG(imgSVG_1) {
        return __awaiter(this, arguments, void 0, function* (imgSVG, w = 24, h = 24, a = 1) {
            const aim_W = w;
            const aim_H = h;
            const globalAlpha = a;
            return yield new Promise((resolve, reject) => {
                const div = document.createElement('div');
                div.innerHTML = imgSVG.trim();
                const svgarr = div.getElementsByTagName('svg');
                const svgEL = svgarr[0];
                const width = svgEL.getAttribute('width');
                const height = svgEL.getAttribute('height');
                svgEL.setAttribute('width', aim_W.toString());
                svgEL.setAttribute('height', aim_H.toString());
                const viewBoxStr = `0 0 ${parseInt(width)} ${parseInt(height)}`;
                svgEL.setAttribute('viewBox', viewBoxStr);
                const svg = svgEL;
                const xml = new XMLSerializer().serializeToString(svg);
                // make it base64
                const svg64 = btoa(xml);
                const b64Start = 'data:image/svg+xml;base64,';
                // prepend a "header"
                const image64 = b64Start + svg64;
                const canvas = document.createElement('canvas');
                canvas.width = aim_W + 4; // add some place for img rounding
                canvas.height = aim_H + 4; // add some place for img rounding
                // set it as the source of the img element
                const img = new Image();
                img.src = image64;
                img.onload = function () {
                    const ctx = canvas.getContext('2d');
                    ctx.globalAlpha = globalAlpha;
                    ctx.drawImage(img, 2, 2); // add some place for img rounding
                    const img_png = new Image();
                    img_png.src = canvas.toDataURL('image/png', 1); // best png quolity
                    img_png.onload = () => {
                        resolve(img_png);
                    };
                };
            });
        });
    }
    LoadIMG(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.onreadystatechange = function () {
                    if (this.readyState !== 4) {
                        return;
                    }
                    if (this.status !== 200) {
                        resolve(null);
                        return;
                    }
                    resolve(this.responseText.trim());
                };
                xhr.send();
            });
        });
    }
    InitDB() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof window === 'undefined') {
                return {};
            }
            return yield new Promise((resolve, reject) => {
                const openRequest = indexedDB.open(_ImagesManager.DB_NAME, 1);
                openRequest.onerror = function (event) {
                    resolve(null);
                    // console.log("Error", openRequest.error);
                };
                openRequest.onsuccess = function (event) {
                    // console.log("Opened");
                    resolve(event.target.result);
                };
                openRequest.onupgradeneeded = function (event) {
                    // console.log("onupgradeneeded");
                    const db = event.target.result;
                    if (!db.objectStoreNames.contains(_ImagesManager.DB_STORE_NAME)) {
                        // если хранилище "images" не существует
                        db.createObjectStore(_ImagesManager.DB_STORE_NAME, { keyPath: 'id' }); // создаем хранилище
                    }
                    resolve(db);
                };
                // продолжить работу с базой данных, используя объект db
            });
        });
    }
    DB_Add(db, key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = db.transaction(_ImagesManager.DB_STORE_NAME, 'readwrite');
            const images = transaction.objectStore(_ImagesManager.DB_STORE_NAME);
            const image = {
                id: key,
                value
            };
            return yield new Promise((resolve, reject) => {
                const request = images.add(image);
                request.onsuccess = function () {
                    resolve(null);
                    // console.log("картинка добавлена в хранилище", request.result);
                };
                request.onerror = function (event) {
                    if (event.target.error.name === 'ConstraintError') {
                        resolve(null);
                    }
                    else {
                        reject('DB_Add Error');
                    }
                    // console.log("Помилка додавання:", request.error);
                };
            });
        });
    }
    DB_Get(db, key) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = db.transaction(_ImagesManager.DB_STORE_NAME, 'readwrite');
            const images = transaction.objectStore(_ImagesManager.DB_STORE_NAME);
            const data = { success: false, imgData: null };
            return yield new Promise((resolve, reject) => {
                const request = images.get(key);
                request.onsuccess = function () {
                    if (request.result !== undefined) {
                        data.success = true;
                        data.imgData = request.result.value;
                        resolve(data);
                        // console.log("yes", request.result);
                    }
                    else {
                        resolve(data);
                        // console.log("no");
                    }
                };
                request.onerror = function () {
                    reject('DB_Get Error');
                    // console.log("Ошибка ебаная", request.error);
                };
            });
        });
    }
    getSHA256(imgName) {
        return __awaiter(this, void 0, void 0, function* () {
            const hex = yield this.digestMessage(imgName);
            return hex;
        });
    }
    digestMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const hash = new Sha256();
            hash.update(message);
            const hashBuffer = yield hash.digest();
            // Перетворення буфера хеш-значення в шістнадцятковий рядок
            // const msgUint8 = new TextEncoder().encode(message);                           // encode as (utf-8) Uint8Array
            // const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
            const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
            const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
            return hashHex;
        });
    }
}
_ImagesManager.DB_NAME = 'InstrumentImages';
_ImagesManager.DB_STORE_NAME = 'images';
export const ImagesManager = new _ImagesManager();
